
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { NotificationSetting, NotificationTimeOffsetUnit, NotificationSettingConfig } from 'ah-api-gateways';
import { makeFormModel, updateModel, setState, getChildModel } from 'ah-common-lib/src/form/helpers';
import { textField, selectField } from 'ah-common-lib/src/form/models';
import { FormEvent } from 'ah-common-lib/src/form/interfaces';

const HOUR_MAX_VALUE = 72;
const DAYS_MAX_VALUE = 100;
const MONTHS_MAX_VALUE = 2;

const notificationTimeFormModel = () =>
  makeFormModel({
    name: 'notificationTime',
    fieldType: 'form',
    state: {
      formClass: 'notification-time-form',
      hideErrorMessages: true,
    },
    fields: [
      textField('timeValue', '', {
        fieldType: 'number',
        fieldWrapperClass: 'amount-field',
        min: 1,
        max: 100,
        step: 1,
      }),
      selectField(
        'timeUnit',
        '',
        [
          {
            label: 'hours',
            value: NotificationTimeOffsetUnit.HOURS,
          },
          {
            label: 'days',
            value: NotificationTimeOffsetUnit.DAYS,
          },
          {
            label: 'months',
            value: NotificationTimeOffsetUnit.MONTHS,
          },
        ],
        {
          fieldWrapperClass: 'amount-type-field',
        }
      ),
    ],
  });

@Component
export default class SingleNotificationTimeEditForm extends Vue {
  @Prop({ required: true }) config!: NotificationSettingConfig;

  @Prop({ required: true }) notification!: NotificationSetting;

  @Prop({ default: false }) readonly!: string | boolean;

  notificationTimeFormModel = notificationTimeFormModel();

  beforeMount() {
    this.onTimeUnitChange();
  }

  get maxTimeValue() {
    if (this.notificationTimeFormModel.timeUnit === NotificationTimeOffsetUnit.HOURS) {
      return HOUR_MAX_VALUE;
    } else if (this.notificationTimeFormModel.timeUnit === NotificationTimeOffsetUnit.DAYS) {
      return DAYS_MAX_VALUE;
    } else return MONTHS_MAX_VALUE;
  }

  @Watch('readonly', { immediate: true })
  onReadonlyChange() {
    setState(this.notificationTimeFormModel, 'readonly', this.readonly !== false);
  }

  @Watch('notification', { immediate: true })
  onNotificationChange() {
    updateModel(this.notificationTimeFormModel, this.notification);
  }

  onTimeUnitChange() {
    setState(getChildModel(this.notificationTimeFormModel, 'timeValue')!, 'max', this.maxTimeValue);
    this.notificationTimeFormModel.timeValue = Math.min(this.notificationTimeFormModel.timeValue, this.maxTimeValue);
  }

  offsetTimeValue(amount: number) {
    this.notificationTimeFormModel.timeValue = Math.max(
      1,
      Math.min(this.maxTimeValue, this.notificationTimeFormModel.timeValue + amount)
    );
    this.updateNotification();
  }

  onFormEvent(event: FormEvent) {
    if (event.event === 'form-field-set-value') {
      if (event.model.$name === 'timeUnit') {
        this.onTimeUnitChange();
      }
      this.updateNotification();
    }
  }

  updateNotification() {
    this.$emit('update:notification', {
      ...this.notification,
      timeValue: this.notificationTimeFormModel.timeValue,
      timeUnit: this.notificationTimeFormModel.timeUnit,
    });
  }
}
